import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { InlineIcon } from '@iconify/react';
import { getLocalIconPath, ICON_CONFIG, isLocalIcon, shouldUseOnlineFallback } from '../config/iconConfig';

// Add blinking keyframes globally (once)
const style = document.createElement('style');
style.innerHTML = `
  @keyframes blink-animation {
    0% { opacity: 1; }
    50% { opacity: 0.2; }
    100% { opacity: 1; }
  }
`;
if (!document.head.querySelector('[data-iconify-blink]')) {
  style.setAttribute('data-iconify-blink', 'true');
  document.head.appendChild(style);
}

Iconify.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  sx: PropTypes.object,
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fallbackToOnline: PropTypes.bool,
  blink: PropTypes.bool,
};

export default function Iconify({
  icon,
  sx,
  color,
  width = ICON_CONFIG.settings.defaultSize,
  height = ICON_CONFIG.settings.defaultSize,
  fallbackToOnline = shouldUseOnlineFallback(),
  blink = false,
  ...other
}) {
  const [svgContent, setSvgContent] = useState(null);

  useEffect(() => {
    if (isLocalIcon(icon)) {
      fetch(getLocalIconPath(icon))
        .then((res) => res.text())
        .then((text) => setSvgContent(text));
    }
  }, [icon]);

  const blinkStyle = blink
    ? {
        animation: 'blink-animation 1s infinite',
      }
    : {};

  if (isLocalIcon(icon) && svgContent) {
    return (
      <span
        style={{
          display: 'inline-block',
          width,
          height,
          verticalAlign: 'middle',
          color: color,
          ...blinkStyle,
          ...sx,
        }}
        dangerouslySetInnerHTML={{ __html: svgContent }}
        {...other}
      />
    );
  }

  if (fallbackToOnline) {
    return (
      <InlineIcon
        color={color}
        icon={icon}
        sx={{
          width,
          height,
          animation: blink ? 'blink-animation 1s infinite' : undefined,
          ...sx,
        }}
        {...other}
      />
    );
  }

  return null;
}
